module.exports = __webpack_public_path__ + "img/order-manual.788801e9.svg";